<template>
    <v-container grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12 md6>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs6>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">Customers ({{ $format.int(pager.totalRecords) }})</h1>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter" :hint="`(${searchAt.text}) Acc No, Customer`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                                <!-- <v-text-field v-model="searchText" append-icon="search" @keyup.native="searchChange" @click:clear="searchChange"></v-text-field> -->
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-data-table :headers="headers" :items="tableData" :loading="isBusy" hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <tr @click="onSelect(props.item)" :class="(props.item.SN_STOP ? 'red-grid-row' : '') + (props.item.xSel ? ' primary white--text' : '')">
                                            <td>
                                                <div>{{ props.item.SN_ACCOUNT }}</div>
                                                <div class="f-m opa-6">{{ props.item.SN_ANALSYS }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.SN_NAME }}</div>
                                                <div class="f-m opa-6">{{ props.item.SN_CONTACT }} {{ props.item.SN_TELENO }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.SN_CUSTYPE }}</div>
                                                <div class="f-m opa-6">&nbsp;</div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="pager.currentPage" :length="pager.pages" :total-visible="5" @next="loadData" @previous="loadData" @input="loadData"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="pager.pageSize" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;" @change="loadData"></v-select>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
            <v-flex xs12 md6>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs8>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">{{ selected.SN_NAME }}</h1>
                            </v-layout>
                        </v-flex>
                        <v-flex xs4>
                            <v-layout align-center justify-end row fill-height>
                                <v-menu offset-y>
                                    <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                                    <v-list>
                                        <v-list-tile v-for="(item, index) in infoMenuItems" :key="index" class="list-auto-h" @click="onInfoMenu(item)">
                                            <v-list-tile-sub-title>{{ item.value }}</v-list-tile-sub-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                        <!-- <v-flex xs12>
                            <v-tabs v-model="infoTab">
                                <v-tab>Information</v-tab>
                                <v-tab>Notes</v-tab>
                            </v-tabs>
                        </v-flex> -->
                        <v-flex xs12 v-if="selected.SN_STOP">
                            <v-card class="mx-auto red white--text">
                                <v-card-title class="f-l f-b text-xs-center d-block">ON STOP</v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 v-if="showTitles">Totals</v-flex>
                        <v-flex xs12 sm6 md6 lg4>
                            <v-card :class="`mx-auto ${totals.Quotes.Count ? 'accent white--text f-b' : ''}`">
                                <v-card-title class="pb-2">
                                    <div>
                                        <div>{{ $format.int(totals.Quotes.Count) }} Quotes</div>
                                        <div class="f-l">{{ $format.currency(totals.Quotes.Total) }}</div>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg4>
                            <v-card :class="`mx-auto ${totals.Orders.Count ? 'accent white--text f-b' : ''}`">
                                <v-card-title class="pb-2">
                                    <div>
                                        <div>{{ $format.int(totals.Orders.Count) }} Orders</div>
                                        <div class="f-l">{{ $format.currency(totals.Orders.Total) }}</div>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg4>
                            <v-card :class="`mx-auto ${totals.Invoices.Count ? 'accent white--text f-b' : ''}`">
                                <v-card-title class="pb-2">
                                    <div>
                                        <div>{{ $format.int(totals.Invoices.Count) }} Invoices</div>
                                        <div class="f-l">{{ $format.currency(totals.Invoices.Total) }}</div>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <v-card class="mx-auto">
                                <v-card-title class="pb-2">
                                    <table class="w-full">
                                        <tr>
                                            <td class="b-b">Current Balance</td>
                                            <td class="b-b el-text-right">{{ $format.currency(selected.SN_CURRBAL) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="b-b">Turnover</td>
                                            <td class="b-b el-text-right">{{ $format.currency(selected.SN_TRNOVER) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="b-b">Order Balance</td>
                                            <td class="b-b el-text-right">{{ $format.currency(selected.SN_ORDRBAL) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="">Credit Limit</td>
                                            <td class="el-text-right">{{ $format.currency(selected.SN_CRLIM) }}</td>
                                        </tr>
                                    </table>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn class="ma-0" small :disabled="!hasCustomer" @click="onNewQuote">New Quote</v-btn>
                            <v-btn class="ma-0" small disabled>Send Email</v-btn>
                            <v-btn class="ma-0" small disabled>Add Note</v-btn>
                        </v-flex>
                        <v-flex xs12 v-if="selected.DIST_TYPE || selected.CUST_TYPE || selected.DISC">
                            <v-chip v-if="selected.DIST_TYPE" label color="blue-grey darken-1" class="white--text small-tag">{{ selected.DIST_TYPE }}</v-chip>
                            <v-chip v-if="selected.CUST_TYPE" label color="lime darken-4" class="white--text small-tag">{{ selected.CUST_TYPE }}</v-chip>
                            <v-chip v-if="selected.DISC" label color="green darken-2" class="white--text small-tag">{{ selected.DISC }}</v-chip>
                        </v-flex>
                        <v-flex xs12 v-if="showTitles">Addresses</v-flex>
                        <v-flex xs12 sm6>
                            <v-card class="mx-auto">
                                <v-card-title style="min-height:170px; align-items:start;">
                                    <div>
                                        <div class="font-weight-light mb-1">Physical Address</div>
                                        <div v-for="item in selected.Physical" :key="item">{{ item }}</div>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-card class="mx-auto">
                                <v-card-title style="min-height:170px; align-items:start;">
                                    <div>
                                        <div class="font-weight-light mb-1">Postal Address</div>
                                        <div v-for="item in selected.Postal" :key="item">{{ item }}</div>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 v-if="showTitles">Contacts</v-flex>
                        <v-flex xs12>
                            <v-card class="mx-auto">
                                <v-data-table :headers="contactHeaders" :items="contactData" :loading="isBusyContacts" hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <div>{{ props.item.ZC_CONTACT }}</div>
                                                <div class="f-m opa-5">{{ props.item.ZC_EMAIL || " " }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.ZC_POS }}</div>
                                                <div class="f-m opa-5">{{ props.item.ZC_TITLE || " " }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.ZC_PHONE }}</div>
                                                <div class="f-m opa-5">{{ props.item.ZC_MOBILE || " " }}</div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No contacts</v-subheader>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 v-if="showTitles">Notes</v-flex>
                        <v-flex xs12>
                            <v-card class="mx-auto">
                                <v-data-table :headers="noteHeaders" :items="noteData" :loading="isBusyNotes" :total-items="totalNotes" :pagination.sync="paginationNotes" @update:pagination="loadNotes" hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <div class="f-m opa-5">{{ props.item.ZN_SUBJECT || " " }}</div>
                                                <div>{{ props.item.ZN_NOTE }}</div>
                                            </td>
                                            <td>
                                                <div class="f-m opa-5 el-text-right">{{ props.item.SQ_DATE ? $format.dateShort(props.item.SQ_DATE) : " " }}</div>
                                                <div class="el-text-right">{{ props.item.ZN_ACTDATE ? $format.dateShort(props.item.ZN_ACTDATE) : " " }}</div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No notes</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="paginationNotes.page" :length="paginationNotes.pages" :total-visible="5" @next="loadNotes" @previous="loadNotes" @input="loadNotes"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="paginationNotes.size" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;"></v-select>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Dynamics from 'dynamics.js';
import Constants from '../../util/Constants';

export default {
    name: 'Customers',
    data() {
        return {
            title: 'Customers',
            isBusy: false,
            user: { has: () => 0 },
            ViewCompany: {},
            searchText: '',
            searchOptions: Constants.SEARCH_OPTIONS,
            searchAt: {},
            searchAtOptions: Constants.SEARCH_AT_OPTIONS,
            hasCustomer: false,
            selected: { SN_NAME: 'Customer Information' },
            headers: [
                { text: 'Account', value: 'SN_ACCOUNT', align: 'left', width: '100px', sortable: false },
                { text: 'Customer Name', value: 'SN_NAME', align: 'left', sortable: true },
                { text: 'Type', value: 'SN_CUSTYPE', align: 'left', width: '100px', sortable: true },
            ],
            tableData: [],
            pageSizes: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100],
            pager: {
                pageSize: 20,
                currentPage: 1,
                pages: 1,
                totalRecords: 0
            },
            // infoTab: null,
            showTitles: true,
            infoMenuItems: [
                { key: 'hide', value: 'Hide titles' },
                { key: 'show', value: 'Show titles' },
                { key: 'print', value: 'Print' }
            ],
            totals: {
                Quotes: { Count: 0, Total: 0 },
                Orders: { Count: 0, Total: 0 },
                Invoices: { Count: 0, Total: 0 }
            },
            isBusyContacts: false,
            contactHeaders: [
                { text: 'Contact Name', value: 'ZC_CONTACT', align: 'left' },
                { text: 'Position', value: 'ZC_POS', align: 'left', width: '160px' },
                { text: 'Number', value: 'ZC_PHONE', align: 'left', width: '140px' },
            ],
            contactData: [],
            isBusyNotes: false,
            noteHeaders: [
                { text: 'Subject & Note', value: 'ZN_NOTE', align: 'left' },
                { text: 'Dates', value: 'SQ_DATE', align: 'right', width: '140px' },
            ],
            totalNotes: 0,
            noteData: [],
            paginationNotes: {
                page: 1,
                pages: 1,
                records: 0,
                size: 10,
                sortBy: 'SQ_DATE',
                descending: true
            },
        };
    },
    mounted() {
        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.pager.pageSize = this.$ls.get('PageSize_Cust', 20);
        this.showTitles = this.$ls.get('InfoTitles', true);
        this.searchAt = this.searchAtOptions[0];
        this.loadData();
        setTimeout(() => this.$refs.search.focus(), 250);
    },
    methods: {
        async loadData() {
            try {
                this.isBusy = true;
                this.searchText = this.searchText || '';
                const response = await this.$http.post('/Customer/list', { search: this.searchText.trim(), searchAt: this.searchAt.value, C_Id: this.ViewCompany._id, _page: { per: this.pager.pageSize, page: this.pager.currentPage } });
                this.pager.totalRecords = response.data.p.t;
                this.pager.pages = response.data.p.pt;
                const d = response.data.d;
                this.tableData = d;
                if (this.ContextCustomer._id) {
                    const ccust = this.ContextCustomer;
                    const cust = this.tableData.find(o => o._id === ccust._id);
                    if (cust) {
                        this.onSelect(cust);
                    }
                }
                else {
                    this.selected = { SN_NAME: 'Customer Information' };
                    this.contactData = [];
                    this.noteData = [];
                    this.totals = {
                        Quotes: { Count: 0, Total: 0 },
                        Orders: { Count: 0, Total: 0 },
                        Invoices: { Count: 0, Total: 0 }
                    };
                }
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        toggleSearchAt() {
            let pos = this.searchAtOptions.indexOf(this.searchAt);
            pos += 1;
            if (pos === this.searchAtOptions.length) pos = 0;
            this.searchAt = this.searchAtOptions[pos];
            if (this.searchText.trim().length) this.loadData();
            this.$refs.search.focus();
        },
        searchChange() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.pager.currentPage = 1;
                this.loadData();
            }, 600);
        },
        onSelect(row) {
            if (!row) return;
            // this.$router.push({ name: 'CustomerDetail', params: row._id });
            // this.$router.push({ name: 'CustomerDetail', query: { id: row._id } });
            let list;
            if (!row.Physical) {
                list = [];
                if (row.SN_DADDR1) list.push(row.SN_DADDR1);
                if (row.SN_DADDR2) list.push(row.SN_DADDR2);
                if (row.SN_DADDR3) list.push(row.SN_DADDR3);
                if (row.SN_DADDR4) list.push(row.SN_DADDR4);
                if (row.SN_DPSTCO) list.push(row.SN_DPSTCO);
                row.Physical = list;
            }
            if (!row.Postal) {
                list = [];
                if (row.SN_ADDR1) list.push(row.SN_ADDR1);
                if (row.SN_ADDR2) list.push(row.SN_ADDR2);
                if (row.SN_ADDR3) list.push(row.SN_ADDR3);
                if (row.SN_ADDR4) list.push(row.SN_ADDR4);
                if (row.SN_PSTCODE) list.push(row.SN_PSTCODE);
                row.Postal = list;
            }
            const curSel = this.tableData.find(o => o.xSel === true);
            if (curSel) curSel.xSel = false;
            row.xSel = true;
            this.hasCustomer = true;
            this.selected = row;
            this.$customer(this.selected);

            this.loadContacts();
            this.loadTotals();
            this.paginationNotes.page = 1;
            this.paginationNotes.sortBy = 'SQ_DATE';
            this.paginationNotes.descending = false;
            this.loadNotes();
        },
        /* addNew() {
            this.$router.push({ name: 'CustomerDetail', query: { id: '' } });
        } */
        async loadContacts() {
            try {
                this.isBusyContacts = true;
                const response = await this.$http.post('/Customer/contacts', { AccNo: this.selected.SN_ACCOUNT });
                if (response.data.s) {
                    const d = response.data.d;
                    this.contactData = d;
                }
                else {
                    this.$alert({ type: 'error', title: 'Data call failed', message: `${response.data.m}` });
                }
                this.isBusyContacts = false;
            }
            catch (err) {
                this.isBusyContacts = false;
                console.error(err);
                this.$alert({ type: 'error', title: 'Data call failed', message: `${err}` });
            }
        },
        loadTotals() {
            this.$http
                .post('/Customer/totals', { AccNo: this.selected.SN_ACCOUNT })
                .then(response => {
                    if (response.data.s) {
                        const d = response.data.d;
                        // this.totals = d;

                        Dynamics.animate(this.totals.Quotes, {
                            Count: d.Quotes.Count,
                            Total: d.Quotes.Total
                        }, { duration: 200 });
                        Dynamics.animate(this.totals.Orders, {
                            Count: d.Orders.Count,
                            Total: d.Orders.Total
                        }, {
                            duration: 200,
                            // type: Dynamics.easeOut
                        });
                        Dynamics.animate(this.totals.Invoices, {
                            Count: d.Invoices.Count,
                            Total: d.Invoices.Total
                        }, { duration: 200 });
                    }
                    else {
                        this.$alert({ type: 'error', title: 'Data call failed', message: `${response.data.m}` });
                    }
                })
                .catch(error => {
                    this.$alert({ type: 'error', title: 'Data call failed', message: `${error}` });
                });
        },
        loadNotes() {
            // Using total-items, pagination.sync and update:pagination for server side sorting etc. It overrides internal control events.
            const sorting = {};
            if (!this.paginationNotes.sortBy) this.paginationNotes.sortBy = 'SQ_DATE';
            sorting[this.paginationNotes.sortBy] = this.paginationNotes.descending ? 1 : -1;
            this.isBusyNotes = true;
            this.$http
                .post('/Customer/notes', { AccNo: this.selected.SN_ACCOUNT, _page: { page: this.paginationNotes.page, per: this.paginationNotes.size }, _sort: sorting })
                .then(response => {
                    if (response.data.s) {
                        const d = response.data.d;
                        this.totalNotes = response.data.p.t;
                        d.forEach(o => {
                            o.SQ_DATE = !o.SQ_DATE || o.SQ_DATE.startsWith('1899') ? '-' : this.$format.dateShort(o.SQ_DATE);
                            o.ZN_ACTDATE = !o.ZN_ACTDATE || o.ZN_ACTDATE.startsWith('1899') ? '-' : this.$format.dateShort(o.ZN_ACTDATE);
                        });
                        this.noteData = d;
                        this.paginationNotes.page = response.data.p.pn;
                        this.paginationNotes.pages = response.data.p.pt;
                        this.paginationNotes.records = response.data.p.t;
                    }
                    else {
                        this.$alert({ type: 'error', title: 'Data call failed', message: `${response.data.m}` });
                    }
                })
                .catch(error => {
                    this.$alert({ type: 'error', title: 'Data call failed', message: `${error}` });
                })
                .finally(() => {
                    this.isBusyNotes = false;
                });
        },
        onInfoMenu(item) {
            switch (item.key) {
                case 'hide':
                    this.showTitles = false;
                    this.$ls.set('InfoTitles', false);
                    break;
                case 'show':
                    this.showTitles = true;
                    this.$ls.set('InfoTitles', true);
                    break;
                case 'print':
                    this.$alert({ title: 'To be implemented', message: 'To be implemented' });
                    break;
                default: break;
            }
        },
        onNewQuote() {
            this.$router.push({ name: 'Quote' });
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Customer/Customers.vue